// Loading
import React from 'react';
import { PropTypes } from 'prop-types';

const style = {
  zIndex: '9003'
}
export default function Loading({ error, delay }) {
  if (error) {
    return (
      <div style={style} className="uk-width-1-1 uk-background-secondary-dark uk-flex uk-flex-middle uk-align-center">
        <p className="uk-text-lead">
          Error spotted here!{' '}
          <span role="img" aria-label="pile of flames">
            🔥
          </span>
        </p>
      </div>
    );
  } else if (delay) {
    return (
      <div className="common-loading uk-height-1-1 uk-width-1-1 uk-background-secondary-dark uk-light uk-flex uk-flex-middle uk-text-center">
        <p>Loading...</p>
      </div>
    );
  } else {
    return null;
  }
}

Loading.propTypes = {
  error: PropTypes.func,
  delay: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/features/common/Loading.js